module.exports = __webpack_public_path__ + "static/media/mark_in_active.60e5727d.svg";